// extracted by mini-css-extract-plugin
export default {"font-ready-ltr":"_2yqpe","font-ready-rtl":"qdrQ3"};